export enum FieldMode{
    create,
    edit,
    detail
  }